class CustomerReviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    // 元素被添加到DOM时调用
    // 初始化元素
    window.addEventListener('DOMContentLoaded', () => {
      this.observeElement(this, this.handleInViewport.bind(this));
    });
  }

  disconnectedCallback() {
    // 元素从DOM中移除时调用
    // 移除 slick 实例
    this.observer.disconnect();
    this.destroySlick(reviewsWrapper);
  }

  observeElement(element, callback) {
    this.observer = new IntersectionObserver((entries, observerInstance) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          callback();
          // 只执行一次，停止观察
          observerInstance.unobserve(entry.target);
        }
      });
    }, {
      // 视口外 1/2 高度以内触发
      root: null,
      threshold: 0.5
    });
    // 如果已经在视口内,立即执行回调
    if (this.isElementInViewport(element)) {
      callback();
      return;
    }
    this.observer.observe(element);
  }
  // 判断元素是否在视口内
  isElementInViewport(el) {
    const rect = el.getBoundingClientRect();
    return (
      rect.top >= -el.offsetHeight / 2 &&
      rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) + el.offsetHeight / 2
    );
  }

  init() {
    const reviewsWrapper = $(this.querySelector('.reviewlist-wrapper'));
    this.playPauseBtn = this.querySelector(".play-pause-btn");
    this.settings = {
      isPaused: this.getAttribute("data-autoplay") == "true" ? false : true,
      autoplay: this.getAttribute("data-autoplay") == "true" ? true : false,
      speed: parseInt(this.getAttribute("data-speed")) || 3000,
      pauseOnHover: this.getAttribute("data-pauseonhover") == "true" ? true : false,
      arrows: this.getAttribute("data-arrows") == "true" ? true : false,
      dots: this.getAttribute("data-dots") == "true" ? true : false,
    }
    this.initSlick(reviewsWrapper);
  }

  handleInViewport() {
    this.init();
  }

  initSlick(reviewsWrapper) {
    reviewsWrapper.on('init', (slick) => {
      this.includeCarouselInstructions(reviewsWrapper);
    });
    reviewsWrapper.slick({
      infinite: true,
      draggable: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: this.settings.autoplay,
      pauseOnHover: this.settings.pauseOnHover,
      autoplaySpeed: this.settings.speed,
      prevArrow: '<button type="button" class="slick-prev" role="button" aria-label="Previous" tabindex="0"><svg aria-hidden="true" aria-labelledby="customer-reviews-prev" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 17 33"><title id="customer-reviews-prev">Prev Customer Reviews</title><g id="7f9a1925-e8c7-4614-8787-3c6095a9f6e1" data-name="Layer 2"><g id="c9b7920a-81fa-4bfe-ad13-4da717c6854b" data-name="Layer 1"><g id="c2d982ff-0cf6-4220-b365-47f30d708fea" data-name="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="f51d455e-6b9c-4c4e-96db-a5004582beda" data-name="8e584754-6657-46f1-a9d8-2cfd6623b552"><polygon fill="currentColor" points="0 16.5 2.1 18.5 17 33 17 29.3 5.9 18.5 3.8 16.5 5.9 14.5 17 3.7 17 0 2.1 14.5 0 16.5"></polygon></g></g></g></g></svg><span hidden="hidden">Previous</span></button>',
      nextArrow: '<button type="button" class="slick-next" role="button" aria-label="Next" tabindex="0"><svg aria-hidden="true" aria-labelledby="customer-reviews-next" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 17 33" xml:space="preserve"><title id="customer-reviews-next">Next Customer Reviews</title><g id="e4eb89a6-f885-43b8-9259-0d6b1516fab0"><g id="_x38_e584754-6657-46f1-a9d8-2cfd6623b552"><g><polygon fill="currentColor" points="14.9,14.5 0,0 0,3.7 11.1,14.5 13.2,16.5 11.1,18.5 0,29.3 0,33 14.9,18.5 17,16.5 "></polygon></g></g></g></svg><span hidden="hidden">Next</span></button>',
      arrows: this.settings.arrows,
      dots: this.settings.dots
    });
    let playPauseBtn = this.playPauseBtn;
    playPauseBtn?.addEventListener("click", () => {
      if (this.settings.isPaused) {
        reviewsWrapper.slick('slickPlay');
        playPauseBtn.innerHTML = '<svg aria-label="Pause Auto Slide" aria-labelledby="pause-slide-title" class="icon " aria-hidden="true" t="1713405533408" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="10166" width="32" height="32"><title id="pause-slide-title">Pause Auto Slide</title><path d="M413.866667 320c-17.066667 0-32 14.933333-32 32v320c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-320c0-17.066667-14.933333-32-32-32zM605.866667 320c-17.066667 0-32 14.933333-32 32v320c0 17.066667 14.933333 32 32 32s32-14.933333 32-32v-320c0-17.066667-14.933333-32-32-32z" fill="currentColor" p-id="10167"></path><path d="M509.866667 32C245.333333 32 32 247.466667 32 512s213.333333 480 477.866667 480S987.733333 776.533333 987.733333 512 774.4 32 509.866667 32z m0 896C281.6 928 96 742.4 96 512S281.6 96 509.866667 96 923.733333 281.6 923.733333 512s-185.6 416-413.866666 416z" fill="currentColor" p-id="10168"></path></svg>';
      } else {
        reviewsWrapper.slick('slickPause');
        playPauseBtn.innerHTML = '<svg aria-label="Enable Auto Slide" aria-labelledby="play-slide-title" class="icon" aria-hidden="true" data-prefix="fal" data-icon="play-circle" viewBox="0 0 512 512" class="svg-inline--fa fa-play-circle fa-w-16 fa-3x"><title id="play-slide-title">Enable Auto Slide</title><path fill="currentColor" d="M256 504c137 0 248-111 248-248S393 8 256 8 8 119 8 256s111 248 248 248zM40 256c0-118.7 96.1-216 216-216 118.7 0 216 96.1 216 216 0 118.7-96.1 216-216 216-118.7 0-216-96.1-216-216zm331.7-18l-176-107c-15.8-8.8-35.7 2.5-35.7 21v208c0 18.4 19.8 29.8 35.7 21l176-101c16.4-9.1 16.4-32.8 0-42zM192 335.8V176.9c0-4.7 5.1-7.6 9.1-5.1l134.5 81.7c3.9 2.4 3.8 8.1-.1 10.3L201 341c-4 2.3-9-.6-9-5.2z" class=""></path></svg>';
      }
      this.settings.isPaused = !this.settings.isPaused;
    });
  }

  destroySlick(reviewsWrapper = $(this.querySelector('.reviewlist-wrapper'))) {
    if (reviewsWrapper.hasClass('slick-initialized')) {
      reviewsWrapper.slick('unslick');
    }
  }
  // ADA: functioning as a carousel: include the carousel markup and screen reader only instructions
  includeCarouselInstructions(reviewsWrapper) {
    let srOnlyHtml = `<p class="sr-only">This is a carousel. Use navigation buttons to navigate.</p>`;
    reviewsWrapper.parent()?.attr({'role': 'region', 'aria-label': 'Customer Reviews Carousel'});
    if(reviewsWrapper.siblings('.sr-only').length == 0) {reviewsWrapper.before(srOnlyHtml);}
  }
}

// 注册自定义元素
customElements.define("customer-reviews", CustomerReviews);
